<template>
  <div class="loading">
    <div class="loading-children"></div>
  </div>
</template>

<script>
export default {
  name: "LoadingComponent"
};
</script>
